import { styled } from "@mui/material";
import { loginLayoutName } from "../classes.js";
const Root = styled("div", {
  name: loginLayoutName,
  slot: "Root",
  overridesResolver: (_, styles) => styles.root
})(() => ({
  width: "100%",
  height: "100%",
  display: "flex",
  position: "relative",
  alignItems: "center",
  flexDirection: "row",
  justifyContent: "center"
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
